import {
  ApolloClient,
  // createHttpLink,
  InMemoryCache,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { createUploadLink } from 'apollo-upload-client';

// const httpLink = createHttpLink({
//   uri: process.env.REACT_APP_GRAPHQL_URL,
// });

const httpLink = createUploadLink({
  uri: process.env.REACT_APP_GRAPHQL_URL,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const cache = new InMemoryCache({
  // typePolicies: {
  //   Query: {
  //     fields: {
  //       getEmployees: {
  //         // Don't cache separate results based on
  //         // any of this field's arguments.
  //         keyArgs: false,
  //         // Concatenate the incoming list items with
  //         // the existing list items.
  //         merge(existing = [], incoming) {
  //           return [...existing, ...incoming.data];
  //         },
  //       },
  //     },
  //   },
  // },
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
      if (message === 'Unauthenticated.') { //TODO: should be some code based
        localStorage.removeItem('token');
      }
    });

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const client = new ApolloClient({
  link: from([authLink, errorLink, httpLink]),
  cache: cache,
  onError: ({ graphQLErrors, networkError, operation, forward }) => {
    console.log('graphQLErrors22222////', graphQLErrors);
    if (graphQLErrors) {
      console.log('graphQLErrors////', graphQLErrors);
      for (let err of graphQLErrors) {
        console.log('ApolloClient err///', err);
      }
    }
  },
  connectToDevTools: true,
});

export default client;
